class CpfUtils {
	static formatCpf(cpf) {
		const digits = cpf.replace(/\D/g, '');
		return digits.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, "$1.$2.$3-$4");
	}

	static cleanCpf(cpf) {
		return cpf.replace(/\D/g, '');
	}
}

export default CpfUtils;
